import { useHead } from "@unhead/react"
import IngredientSpreadsheet from "@/components/IngredientSpreadsheet"
import YieldScalingCard from "@/components/YieldScalingCard"
import SourdoughCard from "@/components/SourdoughCard"
import PanConverterCard from "@/components/PanConverterCard"
import DoughStagesCard from "@/components/DoughStagesCard"
import ActionFooter from "@/components/ActionFooter"
import EducationalSection from "@/components/EducationalSection"
import PrintableFormula from "@/components/PrintableFormula"

export default function Home() {
  useHead({
    title: "Baker's Conversion Calculator | Free Baker's Percentage & Sourdough Scaling",
    meta: [
      {
        name: "description",
        content:
          "The ultimate free bakers conversion calculator. Calculate baker's percentages, scale true sourdough hydration, convert baking pan sizes, and manage complex baking formulas online without a spreadsheet.",
      },
    ],
  })

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
        {/* SEO Header */}
        <div className="mb-6 sm:mb-8 lg:mb-10 max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight mb-3 sm:mb-4">
            Free Bakers Conversion Calculator &amp; Baker's Percentage Engine
          </h1>
          <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
            The professional baker's math tool that eliminates manual spreadsheet work. Input ingredient weights, get baker's percentages instantly — or work backwards from percentages to weights. Scale recipes to any yield, compute true sourdough hydration accounting for starter's hidden flour and water, and convert between pan sizes with geometric precision.
          </p>
        </div>

        {/* Two-column grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 sm:gap-6 lg:gap-7 items-start">
          {/* Column 1 — Reactive Spreadsheet */}
          <div className="lg:sticky lg:top-20">
            <IngredientSpreadsheet />
          </div>

          {/* Column 2 — Control Panel */}
          <div className="space-y-4 sm:space-y-5">
            <YieldScalingCard />
            <SourdoughCard />
            <DoughStagesCard />
            <PanConverterCard />
          </div>
        </div>

        {/* Action Footer */}
        <div className="mt-6 sm:mt-7 lg:mt-8">
          <ActionFooter />
        </div>

        {/* Educational Section */}
        <div className="mt-6 sm:mt-7 lg:mt-8 no-print">
          <EducationalSection />
        </div>
      </div>

      {/* Printable / PDF export layout — hidden on screen, shown only when printing */}
      <PrintableFormula />
    </div>
  )
}
